import './App.css';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import { PrivateRoute } from './components/router/PrivateRoute';
import axios from 'axios';
import StakesState from './context/buyStakes/StakesState';
// import EventCard from './components/card/EventCard';
// import BettingCard from './components/card/homePageCard/BettingCard';
// import Footer from './components/layout/Footer';
// import Navbar from './components/layout/navbar/Navbar';
// import Navbar1 from './components/layout/navbar/Navbar1';
// import LandingPage from './screens/LandingPage';
import About from './screens/About';
// import Header from './components/layout/Header';
// import HomeHeader from './components/layout/HomeHeader';
import BuyStakes from './screens/BuyStakes';
// import LogIn1 from './components/login/LogIn1';
// import SignUp1 from './components/signup/SignUp1';
import ProfilePage from './screens/ProfilePage';
import LandingPage from './screens/LandingPage';
import MyEvent from './screens/MyEvent';
import Payment from './screens/Payment';
import ScrollToTop from './components/ScrollToTop';
import GameDescription from './screens/GameDescription';
import AdminLogin from './screens/AdminLogin';
import AdminPage from './screens/AdminPage';
import Dashboard from './screens/Dashboard';
import AdminRegisterEvent from './screens/AdminRegisterEvent';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <>
        <Switch>
          {/* <Route
            exact
            path='/'
            component={() => <Redirect to='/landingpage' />}
          /> */}
          {/* <Route exact path="/adminpage" component={AdminPage} />
          <Route exact path="/adminlogin" component={AdminLogin} /> */}
          <Route exact path='/' component={LandingPage} />
          <Route exact path='/buystakes' component={BuyStakes}></Route>
          <Route exact path='/about' component={About}></Route>
          <Route exact path='/profilepage' component={ProfilePage}></Route>
          <Route exact path='/eventpage' component={MyEvent}></Route>
          <PrivateRoute exeact path='/paymentpage' component={Payment}></PrivateRoute>
          <Route
            exact
            path='/gamedescription/:_id'
            component={GameDescription}
          ></Route>
        </Switch>
      </>
    </Router>
  );
}

export default App;
